import React, { Component } from 'react';
import SLUCS from  './RoundedCornerSluCS.png'
import Collins from  './RoundedCornerCollins.png'
import Studiohammer from  './EditedPortfolioUXResearch.png'
import Capstone from  './SatelliteChat.png'

class NewPortfolio extends Component {

  render() {

    if(this.props.data){      
      var project0main = this.props.data.project0main.map(function(project0main){
        return <div key={project0main.overview}>
        <p>{project0main.overview}</p></div>
      })
      var project0details = this.props.data.project0details.map(function(project0details){
        return <div key={project0details.details}>
        <p>{project0details.details}</p></div>
      })
      var project1main = this.props.data.project1main.map(function(project1main){
        return <div key={project1main.overview}>
        <p>{project1main.overview}</p></div>
      })
      var project1details = this.props.data.project1details.map(function(project1details){
        return <div key={project1details.details}>
        <p>{project1details.details}</p></div>
      })
      var project2main = this.props.data.project2main.map(function(project2main){
        return <div key={project2main.overview}>
        <p>{project2main.overview}</p></div>
      })
      var project2details = this.props.data.project2details.map(function(project2details){
        return <div key={project2details.details}>
        <p>{project2details.details}</p></div>
      })
      var project3main = this.props.data.project3main.map(function(project3main){
          return <div key={project3main.overview}>
          <p>{project3main.overview}</p></div>
        })
      var project3details = this.props.data.project3details.map(function(project3details){
        return <div key={project3details.details}>
        <p>{project3details.details}</p></div>
      })
    }

    return (
      <section id="project">
      
      <h2>My Recent Work</h2>

      <div className="row project0">
            <div className="eight columns main-col">
                 <img className="project-pic"  src={Capstone} />
            </div>
               <div className="four columns">
                 {project0main}
                 {project0details}
                 <li><a href='https://drive.google.com/file/d/1KmGYST4wmmjYJMI3H3bw_d2U588aiXJ6/view?usp=sharing'>View Case Study</a></li>

               </div>
      </div>

      <div className="row project1">
            <div className="eight columns main-col">
                 <img className="project-pic"  src={Collins} />
            </div>
               <div className="four columns">
                 {project1main}
                 {project1details}
                 <li><a href='https://drive.google.com/file/d/1ZZWb3eEqN0GgJABfUgUS37mRKT-as6NI/view?usp=sharing'>View Designs</a></li>

               </div>
      </div>


      <div className="row project2">
            <div className="eight columns main-col">
                 <img className="project-pic"  src={Studiohammer} />
            </div>
               <div className="four columns">
                 {project2main}
                 {project2details}
                 <li><a href='https://drive.google.com/file/d/1HqOgovIdCGXKbUfgZFuemu9bP0wwpMFx/view?usp=sharing'>View Case Study</a></li>
               </div>

      </div>

      <div className="row project2">
            <div className="eight columns main-col">
                 <img className="project-pic"  src={SLUCS} />
            </div>
               <div className="four columns">
                 {project3main}
                 {project3details}
                 <li><a href='https://cs.slu.edu/'>View Website</a></li>
               </div>
      </div>


   </section>
    );
  }
}

export default NewPortfolio;



// WEBPACK FOOTER //
// ./src/Components/NewPortfolio.js